import { _selector } from './_selector';

export function getAllFocusables(elem) {
  return [...elem.querySelectorAll(_selector)];
}
